


















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { SearchCondition } from '@/modules/chat';
import { RecentlyChatMessage, RecentlyChatListResponse } from '@/models/chatResponse';
import { ReadTypes } from '@/enums/readTypes';
import { UserTypes } from '@/enums/userTypes';

@Component
export default class LatelyChat extends Vue {
  private ReadTypes = ReadTypes;
  private UserTypes = UserTypes;

  @Prop({ default: 7 }) private days: number;

  private messages: RecentlyChatMessage[] = [];
  private loading = false;

  private condition: SearchCondition = {
    dateFrom: (this as any).$moment().add(-7, 'days'),
    dateTo: null,
    readType: ReadTypes.All,
    ownOnly: true,
    keyWord: '',
    perPage: 1000000,
    page: 1,
    sort: 'updateDate descending'
  };

  get userId() {
    if (this.$store.state.me.user == null) {
      return null;
    } else {
      return this.$store.state.me.user.id;
    }
  }

  @Watch('userId')
  private changeUserId() {
    this.loadData();
  }

  private created() {
    this.condition.dateFrom = (this as any).$moment().add(-this.days, 'days');
  }

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    if (!this.userId) {
      this.messages = [];
      return;
    }

    this.loading = true;

    const data: RecentlyChatListResponse = await this.$store
      .dispatch('chat/getRecentlyMessages', this.condition)
      .catch((error) => {
        this.messages = [];
        this.loading = false;
        return;
      });
    this.messages = data.recentlyChatMessageList;
    this.loading = false;
  }

  private updateDateFormatter(row: RecentlyChatMessage) {
    if (!row.updateDate) {
      return '';
    } else {
      return (this as any).$moment(row.updateDate).format('YYYY/MM/DD H:mm');
    }
  }

  private onMessageClick(row: RecentlyChatMessage) {
    this.$router.push({
      name: 'ChatMessageView',
      params: {
        tutorId: row.tutorId,
        studentId: row.studentId
      }
    });
  }

  private onMoreClick() {
    const condition: SearchCondition = JSON.parse(
      JSON.stringify(this.condition)
    );
    condition.dateFrom = null;
    condition.dateTo = null;
    this.$router.push({
      name: 'ChatList',
      params: {
        searchCondition: JSON.stringify(condition)
      }
    });
  }
}
